/* @flow strict */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import DataTable from 'react-data-table-component';
import _ from 'lodash';
import { GET } from '/client/src/api';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import TableSkeleton from '/client/src/components/skeletons/dataTableSkeleton';

type PropsType = {
  handleOpenReferralModal: () => void,
  isFormOpen: boolean
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  },
  rows: {
    style: {
      flexShrink: '0'
    }
  },
  cells: {
    style: {
      minWidth: '50px !important'
    }
  }
};

let mock = {
  columns: []
};

export const ReferralsTable = ({ handleOpenReferralModal, isFormOpen }: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);

  const [referralsData, setReferralsData] = React.useState([]);
  const [progressPending, setProgressPending] = React.useState(true);

  try {
    mock = require('./tableHeaders/index.js');
  } catch (e) {
    console.warn('File "./tableHeaders/index.js" doesn\'t exist');
  }

  const fetchReferrals = async () => {
    setProgressPending(true);

    try {
      const { result } = await GET('/api/v1/1/referrals?max_result_count=10000');

      setReferralsData(_.get(result, 'items', []));
      setProgressPending(false);
    } catch (e) {
      console.log(e);
      console.error('cant get referrals data');
      setProgressPending(false);
    }
  };

  React.useEffect(() => {
    if (!isFormOpen) {
      fetchReferrals();
    }
  }, [isFormOpen]);

  return (
    <>
      <div className="navbar-page-toolbar send-mail-navbar panel-heading-color1">
        <div className="container-fluid search-bar">
          <div className="s-table">
            <div className="s-cell s-cell-buttons" style={{ width: '100%' }}>
              <ul className="nav">
                <li style={{ marginRight: '1rem' }} />
                <li
                  onClick={(): any => handleOpenReferralModal(true)}
                >
                  <a href='#'><span>refer</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="panel-body" style={{ padding: 0 }}>
        <div style={{ position: 'relative', minHeight: '120px' }}>
          {!progressPending ?
            <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
              <ReactTooltip
                place="right"
                type="light"
                effect="solid"
                multiline
                border
                borderColor='#ddd'
                backgroundColor='white'
                className='ReactTooltipCustom'
              />
              <DataTable
                columns={mock.columns(context)}
                data={referralsData}
                customStyles={customStyles}
                progressPending={progressPending}
                progressComponent={<TableSkeleton rows={10} columns={mock.columns(context)} />}
                highlightOnHover
                pointerOnHover
                responsive
                striped
                fixedHeader
                noHeader
                sortIcon={(): any =>  (
                    <>
                      <span className="-sort-desc" />
                      <span className="-sort-asc" />
                    </>
                  )}
              />
            </div>
            :
            <div className='csspinner' style={{ top: '50%', left: '0' }} />
          }
        </div>
      </div>
      </>
  );
};
